<template>
  <div class="audit-page">
    <div class="hero-card">
      <div>
        <h1>Historik veprimesh</h1>
        <p>Kush e kreu veprimin, cfare u krye, ku dhe kur.</p>
      </div>
    </div>

    <div class="top-tabs">
      <button v-if="canSeeActivity" class="mode-btn" :class="{ active: activeTab === 'activity' }" @click="activeTab = 'activity'">Veprime</button>
      <button v-if="canSeeErrors" class="mode-btn" :class="{ active: activeTab === 'errors' }" @click="activeTab = 'errors'">Gabime</button>
    </div>

    <div v-if="activeTab === 'activity' && canSeeActivity" class="panel-card">
      <div class="quick-actions">
        <input v-model="activityFilters.search" class="input-clean" type="text" placeholder="Kerko kod, emer, perdorues..." @keyup.enter="applyActivityFilters" />
        <select v-model="activityFilters.module" class="input-clean" style="max-width: 180px" @change="applyActivityFilters">
          <option value="">Te gjitha modulet</option>
          <option value="products">Produkte</option>
          <option value="categories">Pema e kategorive</option>
          <option value="attributes">Pema e atributeve</option>
          <option value="pricing">Cmime</option>
          <option value="offers">Oferta</option>
          <option value="warehouses">Magazina</option>
          <option value="roles">Role</option>
          <option value="users">Perdorues</option>
        </select>
        <select v-model="activityFilters.action" class="input-clean" style="max-width: 180px" @change="applyActivityFilters">
          <option value="">Te gjitha veprimet</option>
          <option value="created">Krijoi</option>
          <option value="updated">Ndryshoi</option>
          <option value="deleted">Fshi</option>
          <option value="imported">Importoi</option>
          <option value="price_changed">Ndryshoi cmimin</option>
          <option value="published">Publikoi</option>
          <option value="moved">Zhvendosi</option>
          <option value="reverted">Riktheu</option>
          <option value="scheduled">Planifikoi</option>
          <option value="cancelled">Anuloi</option>
          <option value="copied">Kopjoi</option>
          <option value="resync_financa">Sinkronizoi F5</option>
        </select>
        <input v-model="activityFilters.from" class="input-clean" type="date" @change="applyActivityFilters" />
        <input v-model="activityFilters.to" class="input-clean" type="date" @change="applyActivityFilters" />
        <button type="button" class="button is-small" @click="applyActivityFilters">Filtro</button>
      </div>

      <div v-if="activityLoading" class="empty-note">Duke ngarkuar veprimet...</div>
      <div v-else-if="!activityItems.length" class="empty-note">Nuk ka veprime te audituara ende.</div>
      <div v-else class="audit-table-wrap">
        <table class="table is-fullwidth is-narrow audit-table">
          <thead>
            <tr>
              <th style="width: 44px"></th>
              <th>Kush</th>
              <th>Veprimi</th>
              <th>Ku</th>
              <th>Kur</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="row in activityItems" :key="`a-${row.id}`">
              <tr class="audit-row" :class="{ 'is-expanded': expandedActivityId === row.id }">
                <td>
                  <button
                    v-if="hasActivityDetails(row)"
                    type="button"
                    class="button is-small is-light audit-expand-btn"
                    @click="toggleActivity(row.id)"
                  >
                    {{ expandedActivityId === row.id ? "−" : "+" }}
                  </button>
                </td>
                <td>
                  <div class="audit-primary">{{ row.actor_name || "—" }}</div>
                </td>
                <td>
                  <div class="audit-primary">{{ row.action_label || row.action }}</div>
                  <div v-if="changeEntries(row).length">
                    <div v-for="(entry, idx) in changeEntries(row)" :key="idx" class="audit-change-line">
                      <span class="has-text-weight-semibold">{{ entry.label }}</span>
                      : {{ entry.old }} → {{ entry.new }}
                    </div>
                  </div>
                  <div v-else class="audit-secondary">{{ row.description }}</div>
                </td>
                <td>
                  <div class="audit-primary">{{ row.module_label }}</div>
                  <div class="audit-secondary">{{ row.source_label }}{{ row.subject_label ? " · " + row.subject_label : "" }}</div>
                </td>
                <td>
                  <div class="audit-primary">{{ formatDateTime(row.created_at) }}</div>
                </td>
              </tr>
              <tr v-if="expandedActivityId === row.id && hasActivityDetails(row)" class="audit-detail-row">
                <td colspan="5">
                  <div class="audit-detail-card">
                    <div v-if="changeEntries(row).length">
                      <table class="table is-narrow is-fullwidth" style="font-size: 12px">
                        <thead>
                          <tr>
                            <th>Fusha</th>
                            <th>Para</th>
                            <th>Mbas</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(entry, idx) in changeEntries(row)" :key="idx">
                            <td>{{ entry.label }}</td>
                            <td>{{ entry.old }}</td>
                            <td>{{ entry.new }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <pre v-else-if="row.meta" class="audit-json">{{ pretty(row.meta) }}</pre>
                    <div v-else class="empty-note" style="margin: 0">Nuk ka detaje shtese.</div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="pager">
        <button type="button" class="button is-small" :disabled="activityPage <= 1" @click="activityPage--; loadActivity()">«</button>
        <span>Faqe {{ activityPage }} / {{ activityTotalPages }}</span>
        <button type="button" class="button is-small" :disabled="activityPage >= activityTotalPages" @click="activityPage++; loadActivity()">»</button>
      </div>
    </div>

    <div v-if="activeTab === 'errors' && canSeeErrors" class="panel-card">
      <div class="quick-actions">
        <input v-model="errorFilters.search" class="input-clean" type="text" placeholder="Kerko mesazh, url, skedar..." @keyup.enter="applyErrorFilters" />
        <select v-model="errorFilters.level" class="input-clean" style="max-width: 160px" @change="applyErrorFilters">
          <option value="">Te gjitha nivelet</option>
          <option value="error">Error</option>
          <option value="warning">Warning</option>
          <option value="critical">Critical</option>
        </select>
        <input v-model="errorFilters.from" class="input-clean" type="date" @change="applyErrorFilters" />
        <input v-model="errorFilters.to" class="input-clean" type="date" @change="applyErrorFilters" />
        <button type="button" class="button is-small" @click="applyErrorFilters">Filtro</button>
      </div>

      <div v-if="errorLoading" class="empty-note">Duke ngarkuar gabimet...</div>
      <div v-else-if="!errorItems.length" class="empty-note">Nuk ka gabime te regjistruara.</div>
      <div v-else class="audit-table-wrap">
        <table class="table is-fullwidth is-narrow audit-table">
          <thead>
            <tr>
              <th style="width: 44px"></th>
              <th>Niveli</th>
              <th>Mesazhi</th>
              <th>Kush</th>
              <th>Kur</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="row in errorItems" :key="`e-${row.id}`">
              <tr class="audit-row" :class="{ 'is-expanded': expandedErrorId === row.id }">
                <td>
                  <button type="button" class="button is-small is-light audit-expand-btn" @click="toggleError(row.id)">
                    {{ expandedErrorId === row.id ? "−" : "+" }}
                  </button>
                </td>
                <td>
                  <span class="chip" :class="row.level === 'warning' ? 'muted' : 'danger'">{{ row.level }}</span>
                </td>
                <td>
                  <div class="audit-primary">{{ row.message }}</div>
                  <div class="audit-secondary">{{ row.url || row.file || "—" }}</div>
                </td>
                <td>{{ row.actor_name || "—" }}</td>
                <td>{{ formatDateTime(row.created_at) }}</td>
              </tr>
              <tr v-if="expandedErrorId === row.id" class="audit-detail-row">
                <td colspan="5">
                  <div class="audit-detail-card">
                    <div v-if="row.file" class="audit-secondary mb-2">{{ row.file }}{{ row.line ? ":" + row.line : "" }}</div>
                    <pre v-if="row.exception" class="audit-json">{{ row.exception }}</pre>
                    <pre v-else-if="row.context" class="audit-json">{{ pretty(row.context) }}</pre>
                    <div v-else class="empty-note" style="margin: 0">Nuk ka kontekst shtese.</div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="pager">
        <button type="button" class="button is-small" :disabled="errorPage <= 1" @click="errorPage--; loadErrors()">«</button>
        <span>Faqe {{ errorPage }} / {{ errorTotalPages }}</span>
        <button type="button" class="button is-small" :disabled="errorPage >= errorTotalPages" @click="errorPage++; loadErrors()">»</button>
      </div>
    </div>
  </div>
</template>

<script>
import permissionMixin from "@/mixins/permissions-mixin.js";
import AuditServices from "@/services/Audit";

export default {
  mixins: [permissionMixin],
  data() {
    return {
      activeTab: "activity",
      activityLoading: false,
      activityItems: [],
      activityPage: 1,
      activityTotal: 0,
      activityPerPage: 30,
      expandedActivityId: null,
      activityFilters: {
        search: "",
        module: "",
        action: "",
        from: "",
        to: "",
      },
      errorLoading: false,
      errorItems: [],
      errorPage: 1,
      errorTotal: 0,
      errorPerPage: 30,
      expandedErrorId: null,
      errorFilters: {
        search: "",
        level: "",
        from: "",
        to: "",
      },
    };
  },
  computed: {
    canSeeActivity() {
      return this.am_allowed("audit_logs.can_see_activity");
    },
    canSeeErrors() {
      return this.am_allowed("audit_logs.can_see_errors");
    },
    activityTotalPages() {
      return Math.max(1, Math.ceil(this.activityTotal / this.activityPerPage));
    },
    errorTotalPages() {
      return Math.max(1, Math.ceil(this.errorTotal / this.errorPerPage));
    },
  },
  watch: {
    activeTab(val) {
      if (val === "errors") this.loadErrors();
      if (val === "activity") this.loadActivity();
    },
  },
  created() {
    if (!this.am_allowed("menu_roles.can_see_audit_logs") && !this.canSeeActivity && !this.canSeeErrors) {
      this.$router.push("/home");
      return;
    }
    if (!this.canSeeActivity && this.canSeeErrors) {
      this.activeTab = "errors";
    }
    if (this.canSeeActivity) this.loadActivity();
    else if (this.canSeeErrors) this.loadErrors();
  },
  methods: {
    applyActivityFilters() {
      this.activityPage = 1;
      this.loadActivity();
    },
    applyErrorFilters() {
      this.errorPage = 1;
      this.loadErrors();
    },
    async loadActivity() {
      this.activityLoading = true;
      try {
        const res = await AuditServices.activity({
          page: this.activityPage,
          per_page: this.activityPerPage,
          search: this.activityFilters.search || undefined,
          module: this.activityFilters.module || undefined,
          action: this.activityFilters.action || undefined,
          from: this.activityFilters.from || undefined,
          to: this.activityFilters.to || undefined,
        });
        this.activityItems = Array.isArray(res?.items) ? res.items : [];
        this.activityTotal = Number(res?.total || 0);
      } catch (e) {
        this.activityItems = [];
        this.activityTotal = 0;
      } finally {
        this.activityLoading = false;
      }
    },
    async loadErrors() {
      this.errorLoading = true;
      try {
        const res = await AuditServices.errors({
          page: this.errorPage,
          per_page: this.errorPerPage,
          search: this.errorFilters.search || undefined,
          level: this.errorFilters.level || undefined,
          from: this.errorFilters.from || undefined,
          to: this.errorFilters.to || undefined,
        });
        this.errorItems = Array.isArray(res?.items) ? res.items : [];
        this.errorTotal = Number(res?.total || 0);
      } catch (e) {
        this.errorItems = [];
        this.errorTotal = 0;
      } finally {
        this.errorLoading = false;
      }
    },
    toggleActivity(id) {
      this.expandedActivityId = this.expandedActivityId === id ? null : id;
    },
    toggleError(id) {
      this.expandedErrorId = this.expandedErrorId === id ? null : id;
    },
    changeEntries(row) {
      if (Array.isArray(row?.changes_list) && row.changes_list.length) {
        return row.changes_list;
      }
      const changes = row?.changes;
      if (!changes || typeof changes !== "object") return [];
      return Object.keys(changes).map((field) => {
        const change = changes[field] || {};
        const label = change.label || field;
        const oldVal = this.formatValue(change.old);
        const newVal = this.formatValue(change.new);
        return {
          field,
          label,
          old: oldVal,
          new: newVal,
          text: `${label}: ${oldVal} → ${newVal}`,
        };
      });
    },
    hasActivityDetails(row) {
      if (this.changeEntries(row).length) return true;
      const meta = row?.meta;
      return !!meta && typeof meta === "object" && Object.keys(meta).length > 0;
    },
    formatValue(value) {
      if (value === null || value === undefined || value === "") return "—";
      if (typeof value === "object") return JSON.stringify(value);
      return String(value);
    },
    pretty(value) {
      try {
        return JSON.stringify(value, null, 2);
      } catch (e) {
        return String(value);
      }
    },
    formatDateTime(value) {
      if (!value) return "—";
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return value;
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
  },
};
</script>

<style scoped>
.audit-page {
  padding: 16px;
  background: linear-gradient(180deg, #f8fbff 0%, #f3f6fb 100%);
  min-height: calc(100vh - 64px);
}
.hero-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 16px;
  margin-bottom: 14px;
}
.hero-card h1 {
  margin: 0 0 4px 0;
  font-size: 22px;
  font-weight: 700;
  color: #111827;
}
.hero-card p {
  margin: 0;
  color: #6b7280;
}
.top-tabs {
  margin-bottom: 10px;
  display: inline-flex;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  overflow: hidden;
}
.mode-btn {
  border: 0;
  background: #fff;
  padding: 8px 14px;
  font-weight: 600;
  cursor: pointer;
}
.mode-btn.active {
  background: #1d4ed8;
  color: #fff;
}
.panel-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 14px;
}
.quick-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}
.input-clean {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 6px 10px;
  min-width: 160px;
}
.empty-note {
  color: #6b7280;
  padding: 16px 0;
}
.audit-table-wrap {
  max-height: 560px;
  overflow: auto;
}
.audit-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f8fafc;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #6b7280;
  border-bottom: 1px solid #e5e7eb;
}
.audit-row.is-expanded {
  background: #f8fafc;
}
.audit-expand-btn {
  min-width: 32px;
}
.audit-primary {
  font-size: 13px;
  color: #111827;
  font-weight: 600;
}
.audit-secondary {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}
.audit-change-line {
  font-size: 12px;
  line-height: 1.35;
  word-break: break-word;
  color: #374151;
  margin-top: 2px;
}
.audit-detail-row > td {
  background: #f8fafc;
  padding: 10px 12px !important;
  border-top: 0;
}
.audit-detail-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 8px;
  max-height: 280px;
  overflow: auto;
}
.audit-json {
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 12px;
  margin: 0;
}
.chip {
  display: inline-block;
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}
.chip.muted {
  background: #fffbeb;
  color: #92400e;
}
.chip.danger {
  background: #fef2f2;
  color: #b91c1c;
}
.pager {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  font-size: 13px;
  color: #4b5563;
}
</style>
